import { CURRENCY_CODES } from '@watershed/constants/currency';

import { defAlias, defCurrencyUnit } from '../registry';

// Currency cannot be converted using the unit system because it
// is a variable rate, but well-known symbols can participate in unit
// expressions.  One of the ways this plays out is that when you look up
// the exchange rate for a currency pair in a timeframe, the rate can be
// expressed as a relation between the relevant currencies. So:
//
// rate [USD/EUR] * input [EUR] = output [USD]

export const currencyUnits = [
  // fiat
  ...CURRENCY_CODES.map(defCurrencyUnit),
  // crypto
  defCurrencyUnit('BCH'),
  defCurrencyUnit('BSV'),
  defCurrencyUnit('BTC'),
  defCurrencyUnit('CCF'),
  defCurrencyUnit('DOGE'),
  defCurrencyUnit('ETH'),
  defCurrencyUnit('LTC'),
];

defAlias('btc', 'BTC');
